import BriefcaseFill from './BriefcaseFill';

export default BriefcaseFill;
